<template>
    <div style="width: 100%;">
        <div class="card">
            <div class="card-header">
                <h5>Información principal</h5>
            </div>
            <div class="row">
                <div class="col-6 pl-4">
                    <table style="width: 100%;" class="table table-sm">
                        <tr>
                            <th>SKU</th>
                            <td>{{ detail.sku }}</td>
                        </tr>
                        <tr>
                            <th>Marca</th>
                            <td>{{ detail.brand }}</td>
                        </tr>
                        <tr>                            
                            <th>Mezcla Comercial</th>
                            <td>{{ detail.comercialMixCode }}</td>
                        </tr>
                        <tr>
                            <th>Vino</th>
                            <td>{{ detail.variety }} - {{ detail.quality }}</td>
                        </tr>
                        <tr>                            
                            <th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
                            <td>{{ detail.finalHarvest }}</td>
                        </tr>
                        <tr>                            
                            <th>Botellas</th>
                            <td>{{ detail.quantity }}</td>
                        </tr>
                    </table>
                </div>
                <div class="col-6">
                    <table style="width: 100%;" class="table table-sm">
                        <tr>
                            <th colspan="2">
                                Componentes desde Solicitud
                            </th>
                        </tr>
                        <tr v-for="component in  detail.components" :key="component.id">
                            <td>{{ component.name }}</td>
                            <td>
                                <button :disabled="componentToRevision.filter(x => x.originComponentCode == component.c_sku).length > 0" type="button" class="btn btn-success btn-sm" @click="showSelectNewComponent(component)">
                                    <i class="fas fa-exchange-alt"></i>
                                </button>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <div class="card mt-4">
            <div class="card-header">
                <h5>Motivo</h5>
            </div>
            <div class="card-body">
                <input class="form-control" type="text"  v-model="reasonSendToRevision"/>
            </div>
        </div>
        <div class="card mt-4" >
            <div class="card-header">
                <h5>Componentes a Revisión</h5>
            </div>
            <div v-if="componentToRevision.length > 0" class="card-body">
                <div class="row mt-4">
                    <div class="col-12">
                        <div class="table-responsive">
                            <table style="width: 100%;"  class="table table-sm">
                                <tr>
                                    <th>Componente de Origen</th>
                                    <th></th>
                                    <th>Componente Sugerido</th>
                                    <th>Cosecha</th>
                                    <th>Zona de Venta</th>
                                    <th></th>
                                </tr>
                                <tr v-for="(ctoRevision, index) in componentToRevision" :key="index">
                                    <td style="width: 36%;">{{ ctoRevision.originComponentName }}</td>
                                    <td style="width: 5%; text-align: center;"><i class="fas fa-arrow-right"></i></td>
                                    <td style="width: 36%;">{{ ctoRevision.suggestedComponentName }} - {{ ctoRevision.suggestedComponentCode }}</td>
                                    <td style="width: 8%;">{{ ctoRevision.suggestedHarvest }}</td>
                                    <td style="width: 15%;">{{ ctoRevision.suggestedSaleZone }}</td>
                                    <td>
                                        <button type="button" class="btn btn-sm btn-danger" @click="removeNewComponent(index)">
                                            <i class="fas fa-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="componentToRevision.length > 0 && reasonSendToRevision">
            <div class="col">
                <div class="form-group">
                    <button type="button" @click="sendRevisionSamples" class="btn btn-block btn-success">
                        <i class="fa fa-send"></i>
                        Enviar
                    </button>
                </div>
            </div>
        </div>
        <div class="modal fade" data-backdrop="static" data-keyboard="false" v-if="sku" id="selectNewComponent">
            <div class="modal-dialog">
                <div class="modal-content">                
                    <div class="modal-header">
                        <h4 class="modal-title">Seleccionar Nuevo Componente</h4>
                        <button type="button" @click="modalCloseSelectNewComponent" class="close" >&times;</button>
                    </div> 
                    <div class="modal-body">
                        <select-new-component-form @addComponentToRevision="addComponentToRevision" :originComponent="originComponent" :sku="sku"></select-new-component-form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" @click="modalCloseSelectNewComponent" >
                            <i class="fa fa-ban"></i> Cancelar
                        </button>
                        <slot name="btnFooter"></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import $ from "jquery";
export default {
    props: ["detail", "sku"],
    data() {
        return {
            apiUrl: this.$store.getters.apiUrl,
            componentToRevision: [],
            originComponent: {},
            originComponentWithRevition: [],
            reasonSendToRevision: ''
        };
    },
    methods: {
        showSelectNewComponent(component){
            this.originComponent = component;
            $("#selectNewComponent").modal("show");
        },
        removeNewComponent(index){
            this.componentToRevision.splice(index, 1)
        },

        addComponentToRevision(suggestedComponentCode, suggestedComponentName, suggestedHarvest, suggestedSaleZone){
            this.componentToRevision.push({
                originComponentCode: this.originComponent.c_sku,
                originComponentName: this.originComponent.name,
                suggestedComponentCode: suggestedComponentCode,
                suggestedComponentName: suggestedComponentName,
                suggestedHarvest: suggestedHarvest,
                suggestedSaleZone: suggestedSaleZone
            });
            this.modalCloseSelectNewComponent();
        },
        modalCloseSelectNewComponent(){
            $("#selectNewComponent").modal("hide");
            this.originComponent = null;
        },
        sendRevisionSamples(){
            this.detail.requestChangeFlowHistoryComponents = this.componentToRevision;
            this.detail.reasonSendToRevision = this.reasonSendToRevision;

            this.$emit('sendComponentRevisionSamples', this.detail);

        }
    },
};
</script>
  